import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import App from "./App";
import "./index.css";
import { AOSInit } from "./libs/Aos";
// import { AOSInit } from "@/components/Aos";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <AOSInit />
    <App />
  </React.StrictMode>
);

reportWebVitals();
